import React from 'react';
import './Hero.css';

const Hero = () => {
  return <div className="hero" />;
};

export default Hero;
